<template>
  <DatatableReportV3
    id="quotes-table"
    ref="quote_datatable"
    title="Quotes"
    class="no-cursor"
    :config="config"
    :source="source"
    :filters="filters"
    :map-records="applyFilter"
    subpage
    :flat="flat"
    :min-height="400"
    no-download
  >
    <template #column-quote_link="row">
      <!-- eslint-disable-next-line vue/no-v-html -->
      <span @click="viewQuote(row, $event)" v-html="row.columnValue"></span>
    </template>
    <template #column-invoice_link="row">
      <!-- eslint-disable-next-line vue/no-v-html -->
      <span @click="viewInvoice(row, $event)" v-html="row.columnValue"></span>
    </template>
    <template #actions>
      <slot name="actions"></slot>
    </template>
  </DatatableReportV3>
</template>

<script>
import { EventBus } from "@/lib/event_bus.js";
import { updatePath } from "@/lib/url.js";

import Badge from "@/components/Badge.vue";
import CONSTANTS from "@/Constants.js";
import DatatableReportV3 from "@/Reports/DatatableReportV3.vue";
import store from "@/vuex/store";
import QuoteActionsContextMenu from "./QuoteActionsContextMenu.vue";
import QuoteTableLink from "./QuoteTableLink.vue";

export default {
  components: {
    DatatableReportV3
  },
  props: {
    flat: {
      type: Boolean,
      default: false
    },
    address: {
      type: Object,
      default: null
    },
    source: {
      type: String,
      default: ""
    },
    customerId: {
      type: Number,
      default: null
    },
    showSubCustomers: {
      type: Boolean,
      default: false
    },
    filters: {
      type: Array,
      default: () => []
    }
  },
  emits: ["view-quote"],
  data() {
    return {
      config: {
        order: [[2, "desc"]],
        columns: [
          {
            data: "quote_date",
            title: "Created Date",
            searchable: false
          },
          {
            data: "last_edited_at",
            title: "Last Edited Date",
            searchable: false
          },
          { data: "quote_link", title: "Quote" },
          {
            data: "sent_at",
            title: "Sent",
            orderable: false,
            searchable: false,
            className: "quote-sent-badge"
          },
          { data: "created_by", title: "Created By" },
          {
            data: "quote_status",
            title: "Status",
            filterName: "quote_status",
            searchable: false
          },
          {
            data: "customer",
            title: "Customer",
            orderable: false,
            visible: this.showSubCustomers,
            filterName: "customer_id"
          },
          {
            data: "location_name",
            title: "Location Name",
            visible: !this.address,
            orderable: false
          },
          {
            data: "service_address",
            title: "Service Address",
            orderable: false,
            filterName: "address_id",
            visible: !this.address
          },
          { data: "job", title: "Job" },
          { data: "department", title: "Department" },
          { data: "invoice_link", title: "Invoice" },
          { data: "name", title: "Name" },
          { data: "summary", title: "Summary" },
          {
            data: "item_count",
            title: "Items",
            className: "text-right",
            searchable: false
          },
          {
            data: "promo_code",
            title: "Promo Code",
            filterName: "promo_code"
          },
          {
            data: "promo_code_amount",
            title: "Promo Code Amount",
            className: "text-right",
            searchable: false
          },
          {
            data: "total_cents",
            title: "Total",
            className: "text-right",
            searchable: false,
            footerClassName: "aggregate-currency",
            aggregateTitle: CONSTANTS.AGGREGATE_HEADERS.total
          },
          {
            data: "actions",
            title: "",
            orderable: false,
            searchable: false
          }
        ],
        vueComponents: [
          {
            rootId: "quote-context-menu-vue",
            component: QuoteActionsContextMenu,
            options: {
              store
            }
          },
          {
            rootId: "datatable-quote-link-vue",
            component: QuoteTableLink
          },
          {
            rootId: "badge-vue",
            component: Badge
          }
        ]
      }
    };
  },
  mounted() {
    EventBus.$on("refresh-quote-datatable", this.refreshData);
  },
  beforeUnmount() {
    EventBus.$off("refresh-quote-datatable", this.refreshData);
  },
  methods: {
    applyFilter(record) {
      record.customer_id = this.customerId;
      return record;
    },
    refreshData() {
      this.$refs.quote_datatable.refreshTable();
    },
    viewQuote(row, e) {
      e.preventDefault();
      this.$emit("view-quote", row.DT_RowId, row.customer_id);
    },
    viewInvoice(row, e) {
      if (e.target.tagName !== "A") return;

      e.preventDefault();
      updatePath(e.target.href);
      EventBus.$emit("set-selected-tab", "Invoices");
    }
  }
};
</script>

<style scoped>
:deep(.quote-sent-badge .sera-badge) {
  margin-left: 0px;
  justify-content: center !important;
}

.no-cursor {
  table.dataTable {
    cursor: default;
  }
}
:deep(table.table tr td) {
  white-space: nowrap;
}
</style>
